// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pause-chat-dialog__toggle {
    background: none; 
    border: none; 
    box-shadow: none;
    padding: 0;
    margin: 0;
    text-transform: none;
    color: #039be5;
    font-size: 1.8rem;
    height: auto !important;
    padding: 0 !important;
    line-height: 1.8rem !important;
    display: flex;
    letter-spacing: normal;
    cursor: pointer;
}

.pause-chat-dialog__toggle:hover {
    background: none; 
    border: none; 
    box-shadow: none;
}

.pause-chat-dialog__toggle:focus {
    background: none; 
}

.pause-chat-dialog__menu {
    border: 1px solid;
    width: 35rem;
    height: 20rem;
    transform: translate(6rem, -21rem) !important;  
    text-align: center;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2px 7px 1px rgb(0 0 0 / 75%);
    border-radius: 5px;
    position: absolute !important;
    top: -5rem !important;
    left: 0rem !important;
    z-index: 10;
}

.pause-chat-dialog__select {
    display: block;
    width: 99%;
    margin-left: auto;
    margin-right: auto;
}

.pause-chat-dialog__select:focus-visible {
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
    outline-width: 1px;
}

.pause-chat-dialog__action-btn {
    height: 2.7rem;
    font-size: 0.9rem;
    box-shadow: none;
    border-radius: 0;
    margin: auto auto 0.5rem auto;
    line-height: 0;
}

.pause-chat-dialog__footer {
    width: 100%;
    position: absolute;
    bottom: .5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/pause-chat-dialog/PauseChatDialog.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;IAClB,oCAAoC;IACpC,4CAA4C;IAC5C,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":[".pause-chat-dialog__toggle {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    text-transform: none;\r\n    color: #039be5;\r\n    font-size: 1.8rem;\r\n    height: auto !important;\r\n    padding: 0 !important;\r\n    line-height: 1.8rem !important;\r\n    display: flex;\r\n    letter-spacing: normal;\r\n    cursor: pointer;\r\n}\r\n\r\n.pause-chat-dialog__toggle:hover {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n}\r\n\r\n.pause-chat-dialog__toggle:focus {\r\n    background: none; \r\n}\r\n\r\n.pause-chat-dialog__menu {\r\n    border: 1px solid;\r\n    width: 35rem;\r\n    height: 20rem;\r\n    transform: translate(6rem, -21rem) !important;  \r\n    text-align: center;\r\n    background-color: rgb(255, 255, 255);\r\n    box-shadow: 0px 2px 7px 1px rgb(0 0 0 / 75%);\r\n    border-radius: 5px;\r\n    position: absolute !important;\r\n    top: -5rem !important;\r\n    left: 0rem !important;\r\n    z-index: 10;\r\n}\r\n\r\n.pause-chat-dialog__select {\r\n    display: block;\r\n    width: 99%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.pause-chat-dialog__select:focus-visible {\r\n    outline-color: -webkit-focus-ring-color;\r\n    outline-style: auto;\r\n    outline-width: 1px;\r\n}\r\n\r\n.pause-chat-dialog__action-btn {\r\n    height: 2.7rem;\r\n    font-size: 0.9rem;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    margin: auto auto 0.5rem auto;\r\n    line-height: 0;\r\n}\r\n\r\n.pause-chat-dialog__footer {\r\n    width: 100%;\r\n    position: absolute;\r\n    bottom: .5rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
